import {
  PREMIUM_CALCULATE,
  PREMIUM_CALCULATE_CLEAR_DATA,
  PREMIUM_CALCULATE_ERROR,
  PREMIUM_CALCULATE_SUCCESS,
} from "./actionTypes";

const initialState = {
  loadingCalculate: false,
  responseCalculate: null,
  errorCalculate: null,
};

const PremiumCalculate = (state = initialState, action) => {
  switch (action.type) {
    case PREMIUM_CALCULATE:
      state = {
        ...state,
        loadingCalculate: true,
        responseCalculate: null,
        errorCalculate: null,
      };
      break;
    case PREMIUM_CALCULATE_SUCCESS:
      state = {
        ...state,
        loadingCalculate: false,
        responseCalculate: action.payload,
        errorCalculate: null,
      };
      break;
    case PREMIUM_CALCULATE_ERROR:
      state = {
        ...state,
        loadingCalculate: false,
        responseCalculate: null,
        errorCalculate: action.payload,
      };
      break;
    case PREMIUM_CALCULATE_CLEAR_DATA:
      state = {
        ...state,
        loadingCalculate: null,
        responseCalculate: null,
        errorCalculate: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PremiumCalculate;
